<template>
  <div v-if="photoIdProp != 'abc'" class="image-wrap">
    <img class="img" :src="photoComp" crossOrigin="Anonymous" />
    <span class="close" @click="deleteImage()"
      ><i class="fa fa-trash" title="Delete this photo"></i
    ></span>
  </div>
</template>
<script>
import auth from "../../../auth";
import store from "../../../data/store";

export default {
  props: {
    photoIdProp: String,
    photo: ["photo"],
  },
  data() {
    return {
      filePath: "",
    };
  },
  created: function () {
    var self = this;
    $.ajax(
      "https://www.dupaws.com/services/api/getPetProfilePhoto/" +
        self.photoIdProp,
      {
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        crossDomain: true,
        success: function (data) {
          self.filePath = data.Path;
        },
        error: function () {
          console.log(
            'Couldnt get sitter profile photo "api/getPetProfilePhoto"'
          );
        },
      }
    );
  },
  methods: {
    deleteImage: function () {
      var self = this;
      $.ajax(
        "https://www.dupaws.com/services/api/deletePetProfilePhoto/" +
          self.photoIdProp,
        {
          type: "GET",
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "Authorization",
              "bearer " + localStorage.getItem("access_token")
            );
          },
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          crossDomain: true,
          success: function (data) {
            const index = self.$parent.newPet.PetPhotoDtos.findIndex(
              (t) => t.PetPhotoId === self.photoIdProp
            );
            self.$parent.newPet.PetPhotoDtos.splice(index, 1);
          },
          error: function () {
            console.log("Couldnt delete photo from server");
          },
        }
      );
    },
  },
  computed: {
    photoComp: function () {
      self = this;
      return "https://www.dupaws.com/services" + self.filePath;
    },
  },
};
</script>
<style scoped>
.image-wrap {
  position: relative;
}

.image-wrap:hover .close {
  opacity: 1;
}

.image-wrap .close {
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #fff;
  padding: 3px 2px 2px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  border-radius: 50%;
}

.image-wrap {
  max-width: 100px;
  margin: 2px;
  overflow: hidden;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  min-height: 100px;
  max-height: 200px;
  min-width: 90px;
}

.img {
  width: 100%;
  height: 100%;
  transition: all 1s ease-in;
}

.delete-button {
  position: absolute;
  top: 2px;
}

.image-class:hover img {
  transform: scale(1.4);
  transition: all 1s ease-in;
  filter: brightness(0.5);
}
</style>



// WEBPACK FOOTER //
// PetPicView.vue?cb48cf7e